module.exports = __webpack_public_path__ + "images/empty-states/public-boards-empty.3b170504a0909b828204.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/empty-states/public-boards-empty.svg
// module id = /gB0
// module chunks = 1